// Module
var code = "<div class=\"md-header\"> <div class=\"title\"> <h1>{{editorName}}</h1> <h3></h3> <div class=\"right-actions\"> <button class=\"close-metadatabrowser btn icon\"> <i class=\"material-icons\">close</i> </button> </div> </div> </div> ";
// Exports
export default code;